import styled from '@emotion/styled';
import { Grid, Typography } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { CompetitionState } from '../../../page/ShowProjectPage/ProposalList/ProjectProposalList';
import ButtonWithIcon from '../../primitive/ButtonWithIcon';

type Props = {
  adoptableCount: number;
  checkedCount: number;
  competitionState: CompetitionState;
  onClickButton: () => void;
  className?: string;
};

const ProposalAdoptButton: FC<Props> = ({
  adoptableCount,
  checkedCount,
  competitionState,
  onClickButton,
  className,
}) => {
  return (
    <>
      <Grid container justifyContent={'flex-end'}>
        <Grid item>
          {(() => {
            if (competitionState == 'adoptable') {
              return (
                <CheckedCountText variant="body2">
                  <FormattedMessage
                    id="show_project_page.proposal_list.text"
                    values={{ adoptableCount: adoptableCount, checkedCount: checkedCount }}
                  />
                </CheckedCountText>
              );
            } else if (competitionState == 'purchasable') {
              return (
                <CheckedCountText variant="body2">
                  <FormattedMessage id="show_project_page.proposal_list.additional_purchase_text" />
                </CheckedCountText>
              );
            } else {
              return (
                <CheckedCountText variant="body2" color="error">
                  <FormattedMessage id="show_project_page.proposal_list.text.finished" />
                </CheckedCountText>
              );
            }
          })()}
        </Grid>
        <Grid item>
          {(() => {
            if (competitionState == 'purchasable') {
              return (
                <AdoptButton
                  className={className}
                  disabled={checkedCount < 1}
                  onClick={onClickButton}
                  icon={ShoppingCartIcon}
                >
                  <FormattedMessage id="show_project_page.proposal_list.additional_purchase_button" />
                </AdoptButton>
              );
            } else if (competitionState == 'adoptable') {
              return (
                <AdoptButton
                  className={className}
                  disabled={checkedCount < 1 || adoptableCount < checkedCount}
                  onClick={onClickButton}
                  icon={DoneIcon}
                >
                  <FormattedMessage id="show_project_page.proposal_list.button" />
                </AdoptButton>
              );
            } else {
              return (
                <AdoptButton className={className} disabled={true} onClick={onClickButton} icon={DoneIcon}>
                  <FormattedMessage id="show_project_page.proposal_list.button" />
                </AdoptButton>
              );
            }
          })()}
        </Grid>
      </Grid>
    </>
  );
};

const CheckedCountText = styled(Typography)({
  lineHeight: '40px',
});

const AdoptButton = styled(ButtonWithIcon)({
  padding: '8px 12px',
  marginLeft: '10px',
});

export default ProposalAdoptButton;
